import {
    getUpNextCalendarEventId as getUpNextCalendarEventIdFunction,
    getUpNextCalendarEvent,
} from 'owa-upnext-event-loader';
import { getScenarioUpNextCacheId } from '../selectors/agendaStoreSelectors';
import { ClientItemId } from 'owa-client-ids';
import { OwaDate } from 'owa-datetime';

export function getUpNextCalendarEventId(scenarioId: string): ClientItemId | null {
    const upNextCacheId = getScenarioUpNextCacheId(scenarioId);
    return getUpNextCalendarEventIdFunction(upNextCacheId);
}

export function getUpNextCalendarEventDate(scenarioId: string): OwaDate | null {
    const upNextCacheId = getScenarioUpNextCacheId(scenarioId);
    const upNextEvent = getUpNextCalendarEvent(upNextCacheId);
    return upNextEvent ? upNextEvent.Start : null;
}
